import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './listFooter.module.scss';

export default memo(function ListFooter(props) {
    const [t] = useTranslation('common');

    return (
        <div className={styles.container}>
            <span>{t('common:showing')} {props.visible > 0 ? props.visible : '0'} {t('common:out_of')} {props.total}</span>
        </div>
    );
});
